import { render, staticRenderFns } from "./AegisPackaging.vue?vue&type=template&id=a5f44c58&"
import script from "./AegisPackaging.vue?vue&type=script&lang=js&"
export * from "./AegisPackaging.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports